import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ErroresHandler } from 'src/app/base/tools/handler/error.handler';
import { Certificado } from 'src/app/project/interfaces/certificado';
import { CertificadosService } from 'src/app/project/services/certificados.service';

@Component({
  selector: 'app-certificados',
  templateUrl: './certificados.component.html',
  styleUrls: ['./certificados.component.css']
})
export class CertificadosComponent implements OnInit {

  public certificados: Certificado[];
  public loading: boolean = true;
  public generando: boolean = false;

  displayModal: boolean = false;


  constructor(
    private certificadosService: CertificadosService,
    private messageService: MessageService,
    private erroresHandler: ErroresHandler
    ) { 
  }

  public estados: any[] = [
    {label: 'Ver todo', value: null},
    {label: 'Pendiente de pago', value: 'POR PAGAR'},
    {label: 'Procesando', value: 'GENERANDO'},
    {label: 'Emitidos', value: 'ACTIVO'},
    {label: 'No emitidos', value: 'NO GENERADO'},

  ];

  public ordenar: any[] = [
    {label: 'Primeros certificados', value: 'fechaasc'},
    {label: 'Últimos certificados', value: 'fechadesc'}
  ];


  public certificadosFiltrados: Certificado[] = [];
  public filter = {
    modalidad: null, 
    tipoCurso: null,
    estado: null
  };


  filtrarCertificados(){

    this.loading = true;

      this.certificadosFiltrados = this.certificados.filter(certificado => 

        (this.filter.estado ? certificado.estado == this.filter.estado : true)
      )

      
    setTimeout(() => {
      this.loading = false
    }, 500);
  }

  ordenarCertificados(event){
    this.loading = true;
    switch(event){
      case 'fechaasc':
        this.certificadosFiltrados.sort(function (a, b) {
          return new Date(a.fecha_emision).getTime() - new Date(b.fecha_emision).getTime()
        })
        break;
      case 'fechadesc':
        this.certificadosFiltrados.sort(function (a, b) {
          return new Date(b.fecha_emision).getTime() - new Date(a.fecha_emision).getTime()
        })  
        break;
    }
    
    setTimeout(() => {
      this.loading = false
    }, 500);
    
  }

  generarCertificado(certificado: Certificado, index: number){
    this.certificadosFiltrados[index].loading = true;
    this.certificadosService.generarCertificado(certificado).then((cert: Certificado) => {
      this.certificadosFiltrados[index].loading = false;     
      this.certificadosFiltrados[index] = cert;
      this.certificadosFiltrados[index].curso = certificado.curso;
      this.displayModal = true;
    }); 
  }

  verCertificado(id_certificado: number, index: number){
    this.certificadosFiltrados[index].loading = true;

    if(this.certificadosFiltrados[index].estado == 'ACTIVO' 
      || this.certificadosFiltrados[index].estado == 'GENERADO'){
      this.certificadosFiltrados[index].loading = false;
      window.open(this.certificadosFiltrados[index].verificationLink, "_blank");
    }else{

      this.certificadosService.comprobarDisponibilidad(id_certificado).then(estado => {
        if(estado == 2 ){
          this.certificadosFiltrados[index].estado = 'ACTIVO';
          window.open(this.certificadosFiltrados[index].verificationLink, "_blank");
        }else{
          this.messageService.add({ severity: 'warn', summary: 'Generando certificado', detail: 'Su certificado aún se está generando, por favor inténtelo nuevamente más tarde.' });          
        }
        this.certificadosFiltrados[index].loading = false;
      });
    }
  }

  ngOnInit(): void {
    this.certificadosService.obtenerCertificadosUsuario().then(certificados => {
      this.certificados = certificados;      
      this.filtrarCertificados();
      this.ordenarCertificados('fechadesc');
      
    }).catch(e => {
      this.erroresHandler.processError(
          e,
          'alert',
          'Error al obtener certificados, intente más tarde',
          'Error'
      );
  });

  }

}